import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BankEdit from "./BankEdit";
import BankList from "./BankList";
import BankReferenceField from "./BankReferenceField";
import BankShow from "./BankShow";

export default {
  list: BankList,
  edit: BankEdit,
  show: BankShow,
  BankReferenceField: BankReferenceField,
  icon: AccountBalanceIcon,
  recordRepresentation: "title",
};
